export default (node) => {
  /**
   * Data + elements
   */
  const wrapper = node.querySelector('[data-top-image-wrapper]');
  const slider = node.querySelector('[data-reveal-slider]');

  if (!wrapper || !slider) return;

  /**
   * Functions
   */
  const moveSlider = (clientX) => {
    const rect = node.getBoundingClientRect();
    const offsetX = Math.min(Math.max(0, clientX - rect.left), rect.width);
    const percentage = (offsetX / rect.width) * 100;
    wrapper.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
    slider.style.left = `${percentage}%`;
  };

  const onMouseMove = (e) => {
    moveSlider(e.clientX);
  };

  const onMouseUp = () => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  };

  const onMouseDown = (e) => {
    e.preventDefault();
    moveSlider(e.clientX); // Ensure immediate sync on initial click
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  // Touch event handlers for mobile
  const onTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    if (touch) {
      moveSlider(touch.clientX);
    }
  };

  const onTouchEnd = () => {
    window.removeEventListener('touchmove', onTouchMove, { passive: false });
    window.removeEventListener('touchend', onTouchEnd);
  };

  const onTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    if (touch) {
      moveSlider(touch.clientX); // Ensure immediate sync on initial touch
      window.addEventListener('touchmove', onTouchMove, { passive: false });
      window.addEventListener('touchend', onTouchEnd);
    }
  };

  /**
   * Init
   */
  const init = () => {
    // Mouse events for desktop
    slider.addEventListener('mousedown', onMouseDown);

    // Touch events for mobile
    slider.addEventListener('touchstart', onTouchStart, { passive: false });

    // Prevent default touch behavior to avoid scrolling while dragging
    slider.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
  };

  init();
};
